import type { UserState } from 'hooks/useUserState'
import type { ConfigName } from 'config/utils/config'

export type GateContext = UserState & {
  experimentData: Record<string, string>
  tenant: Tenant
  isDacSkipped: boolean
  amount: number
  primaryIncome: number
  configName?: ConfigName
}

export type GateFn = (ctx: GateContext) => boolean

export type TenantGate = {
  smava?: GateFn
  ffg?: GateFn
}

export type GateDefinition = GateFn | TenantGate

export const isTenantGate = (g: GateDefinition): g is TenantGate =>
  typeof g === 'object' && g !== null && ('smava' in g || 'ffg' in g)
